import React from 'react';
import styled, { useTheme } from 'styled-components';

import media from '../../../utils/mediaQueries';
import { PALE_GREY } from '../../../theme';
import { CustomExamCenters } from './constants';
import { CodengoTitle } from './CodengoTitle';

const Header = styled.div`
  height: 280px;
  ${({ theme: { background } }) => `
    background-color: ${background.color};
    background-image: url("${background.image}");
    background-repeat: ${background.repeat};
    background-position: ${background.position};
    background-size: ${background.size};
  `}
  position: relative;

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
    background-image: url('${(props) => props.theme.background.image2x}');
  }

  ${media.mobile`
    height: 224px;
    background-position: ${(props) => props.theme.background.positionMobile};
  `}
`;

const LogoContainer = styled.div`
  width: 112px;
  height: 56px;
  border-bottom-left-radius: 56px;
  border-bottom-right-radius: 56px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -56px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const Logo = styled.img`
  width: ${(props) => props.theme.logoWidth};
  height: ${(props) => props.theme.logoHeight};
  ${(props) => (props.theme.logoMarginTop ? `margin-top: ${props.theme.logoMarginTop}` : '')};
`;

const Title = styled.h1`
  width: 320px;
  font-weight: 800;
  position: absolute;
  margin: 0;

  ${({ theme: { title } }) => `
    color: ${title.color};
    font-size: ${title.fontSize};
    line-height: ${title.lineHeight};
    letter-spacing: ${title.letterSpacing};
    text-align: ${title.textAlign};
    top: ${title.top};
    left: ${title.left};
    ${title.right ? `right: ${title.right}` : ''};
    ${title.transform ? `transform: ${title.transform}` : ''};
  `}

  ${media.mobile`
    width: 150px;
    ${({ theme: { title } }) => `
      font-size: ${title.fontSizeMobile};
      top: ${title.topMobile};
      left: ${title.leftMobile};
      ${title.rightMobile ? `right: ${title.rightMobile}` : ''};
    `}
  `}
`;

const Intro = styled.div`
  padding: 32px 40px 24px;
  border-bottom: 1px solid ${PALE_GREY};
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;

  ${media.mobile`
    padding: 24px 24px 16px;
  `}
`;

const Name = styled.div`
  margin-bottom: 8px;
`;

const Paragraph = styled.p`
  margin: 0;

  & + & {
    margin-top: 24px;
  }

  ${media.mobile`
    & + & {
      margin-top: 16px;
    }
  `}
`;

const CustomHeader = ({ name, type }: { name: string; type: string }) => {
  const theme = useTheme();

  return (
    <>
      <Header>
        <LogoContainer>
          <Logo src={theme.imagePath} />
        </LogoContainer>
        {type === CustomExamCenters.SGS
          || (type !== CustomExamCenters.CODENGO ? (
            <Title>Votre avis compte pour nous !</Title>
          ) : (
            <CodengoTitle />
          ))}
      </Header>
      <Intro>
        <Name>{`${name},`}</Name>
        <Paragraph>
          Vous avez récemment passé votre examen du code de la route. Donnez votre avis sur le
          déroulement de l’examen et aidez les futurs candidats à choisir leur centre en toute
          connaissance de cause.
        </Paragraph>
        <Paragraph>Cela prend moins d’une minute.</Paragraph>
      </Intro>
    </>
  );
};

export { CustomHeader };
